export default __webpack_public_path__ + "static/media/MBLogo.289e8153.svg";